<vp-link [link]="item().link" className="group" data-test-id="slide">
	<div
		class="slide relative aspect-portrait w-full text-white clip-path-content"
	>
		<vp-image
			[image]="{
				src: item().image.src,
				altText: item().image.alt,
				width: 450,
				height: 600,
			}"
			[sources]="[
				{ min: null, max: sizes.md, width: 300, height: 400 },
				{ min: sizes.md, max: null, width: 450, height: 600 },
			]"
			className="size-full transition-transform duration-300 ease-in-out group-hover:scale-105"
			data-test-id="slide-image"
		/>
		<div
			class="absolute left-0 top-0 size-full bg-gradient-to-t from-[#000000CC] to-transparent to-50%"
		></div>
		<div
			class="text-shadow absolute left-0 top-0 size-full content-end px-6 pb-6"
		>
			<div class="flex flex-col gap-2 font-semibold">
				@if (item().overline) {
					<span
						class="slide-overline line-clamp-2 font-display text-2xl"
						data-test-id="slide-overline"
					>
						{{ item().overline }}
					</span>
				}
				<div class="flex flex-row items-center gap-1 text-lg">
					<span data-test-id="slide-title">
						{{ item().title }}
					</span>
					<svg-icon
						class="flex size-4 transition-spacing group-hover:ml-0.5 md:size-5"
						src="assets/icons/icon-chevron-right.svg"
					/>
				</div>
			</div>
		</div>
	</div>
</vp-link>
